import { Theme } from '@mui/material/styles';

export const helperTextStyles = (theme: Theme) => ({
  helpIcon: {
    p: 0,
    py: 0.5,
    '& svg': { height: 14 }
  }
});
